import { usePreferences } from "../../contexts/PreferencesContext";
import React, { useEffect, useRef, useState } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { FaFileUpload, FaListAlt, FaVideo } from "react-icons/fa";
import { MdDelete, MdFileDownload, MdModeEdit, MdVideoLibrary } from "react-icons/md";
import { Link, useHistory, useParams } from "react-router-dom";
import Search from "../ReusableComponents/Search";

import { Button } from "react-bootstrap";
import Request from "../../Request";
import Pagination from '@material-ui/lab/Pagination';
import { BsFillEyeFill } from "react-icons/bs";
import { logout } from "../../actions/AppActions";
import { useDispatch } from "react-redux";
import { CircularProgress } from "@material-ui/core";
import moment from "moment";
import { saveAs } from 'file-saver';
import ModalFiscaisCsv from "./ModalFiscaisCsv";



const FiscaisVinculados = (props) => {const { t } = usePreferences();

  const [lesson_cards, SetLessonCards] = useState(null);
  const [loading_screen, setLoadingScreen] = useState(true);
  const [loading_fiscais, setLoadingfiscais] = useState(false);
  const [search_oficial, setSearchOficial] = useState('');

  const [fiscais, setfiscais] = useState([]);
  const [pagination, setPagination] = useState({ current_page: 1, last_page: 1 });



  const [search, setSearch] = useState('');
  const { processo_id, processo_name } = props;
  const [show_warning, setShowWarning] = useState(false);
  const [fiscais_id, setRedacaoId] = useState(null);

  const [loading_zip, setLoadingZip] = useState(false);
  const [message_zip, setMessageZip] = useState('');

  const [questaoSelect, setQuestaoSelect] = useState({});

  const [showModal, setShowModal] = useState(false);
  let refs = [];
  const dispatch = useDispatch();

  const Getfiscais = async (page, search) => {

    let response = await Request.Get(`faculdade/get_fiscais_vinculados/${processo_id}?page=${page}&search=${search}`);
    console.log(response);
    if (response === undefined) return;
    if (response['message'] == 'Unauthenticated.') {
      dispatch(logout());
      return;
    }
    console.log(search);
    console.log(search_oficial);
    console.log(page);
    if (response.pagination.current_page == page) {

      setfiscais(response.fiscais);

      setPagination(response.pagination);
      props.setState({total_proctors:response.pagination.total_pages})

      setLoadingScreen(false);
      setLoadingfiscais(false);


    }
  };




  const GetRelatórioFiscal = async (user) => {

    let response = await Request.GetFile(`faculdade/get_relatorio_fiscal/${processo_id}/${user.id}`);
    console.log(response);
    if (response === undefined) return;
    if (response['message'] == 'Unauthenticated.') {
      dispatch(logout());
      return;
    }

    saveAs(response, 'relatorio_' + user.name + '.csv');

  };

  const DeleteRedacao = async (fiscais_id) => {

    let response = await Request.Delete(`faculdade/desvincular_fiscal/${fiscais_id}/${processo_id}`);
    console.log(response);
    if (response === undefined) return;

    if (response['message'] == 'Unauthenticated.') {
      dispatch(logout());
      return;
    }
    Getfiscais(pagination.current_page, search_oficial);



  };


  const GetFiscaisZip = async () => {

    let response = await Request.GetFile(`faculdade/get_relatorios_fiscais/${processo_id}`);
    console.log(response);
    if (response === undefined) return;
    if (response['message'] == 'Unauthenticated.') {
      dispatch(logout());
      return;
    }
    // else if(response['status']==undefined){
    //     setLoadingZip(false);

    //     saveAs(response,'provas_processo_'+processo_name+'.zip');
    // }
    else {
      setLoadingZip(false);
      setMessageZip('');


      saveAs(response, 'relatorios_fiscais_' + processo_name + '.zip');


    }


  };

  useEffect(() => {
    Getfiscais(1, search_oficial);
  }, []);

  let pesquisarTimeout = null;
  const history = useHistory();
  return (
    <div className="row">

            <div className="col-12">


                {/* <hr /> */}
                {loading_screen == false && <div className="module-card-container">

                    <ModalFiscaisCsv
            onFinish={() => {
              setLoadingfiscais(true);
              Getfiscais(1, search_oficial);
            }}
            showModal={showModal}
            setShowModal={(e) => setShowModal(e)}
            processo_id={processo_id}
            processo_name={processo_name} />


                    <div className="module-breadcrumb">

                        <button
              className="breadcrumb-back"
              onClick={() =>
              props.setState({
                activeTab: -1
              })
              }>{t("dashboard")}


            </button>

                        <span>/</span>

                        <strong>{t("proctors")}</strong>

                    </div>

                    <div className="module-title-row">

                        <div>

                            <h3 style={{ fontWeight: 'bold' }}>{`
                                ${t("proctors")}
                            `}</h3>

                            <p>{`
                                ${t("legacy_gerencie_os_fiscais_vinculados_ao_processo")}
                            `}</p>

                        </div>

                        <button
              className="btn-dashboard-modern"
              onClick={() =>
              props.setState({
                activeTab: -1
              })
              }>{`
                            ${t("legacy_dashboard")}
                        `}
            </button>

                    </div>
                    {/* <h4 className="mt-0 header-title" style={{ fontSize: '1.2rem', color: 'black', textAlign: 'center' }}>Questões</h4> */}
                    {/* <br /> */}

                    <div className="module-toolbar">

                        <Search
              placeholder={t("legacy_pesquisar_pelo_nome_do_fiscal")}
              ValueChange={(value) => {

                clearTimeout(pesquisarTimeout);

                setSearchOficial(value);

                pesquisarTimeout = setTimeout(() => {

                  let page = { ...pagination };

                  page.current_page = 1;

                  setPagination(page);

                  setLoadingfiscais(true);

                  Getfiscais(1, value);

                }, 500);

              }} />


                        <div className="module-actions">

                            <button
                onClick={() => {

                  if (!loading_zip) {

                    setLoadingZip(true);

                    setMessageZip(t("loading_generating_zip"));

                    GetFiscaisZip();

                  }

                }}
                className="btn-module-secondary"
                disabled={loading_zip}>


                                {!loading_zip ?

                <>

                                        <MdFileDownload />{`

                                        ${t("legacy_relatorios")}

                                    `}</> :



                <>

                                        <CircularProgress
                    size={16}
                    color="inherit" />


                                        {message_zip}

                                    </>

                }

                            </button>

                            <Link
                to={`/fiscais_vinculados/register/${processo_id}`}
                className="btn-module-primary">


                                <FaListAlt />{`

                                ${t("legacy_adicionar_fiscais")}

                            `}</Link>

                            <button
                onClick={() => {

                  setShowModal(true);

                }}
                className="btn-module-secondary">


                                <FaFileUpload />

                                {t("action_import_csv")}

                            </button>

                        </div>
                    </div>

                    <div className="table-modern-card">
                        <table id="tech-companies-1" className="table table-striped">
                            <thead>
                                <tr>

                                    <th>{t("label_name")}</th>
                                    <th>{t("label_email")}</th>
                                    <th>{t("rooms")}</th>

                                    <th data-priority="3">{t("label_actions")}</th>

                                </tr>
                            </thead>
                            <tbody>
                                {loading_fiscais == false && fiscais.map((item, id) =>

                <tr key={id}>
                                        <td>

                                            <div className="redacao-name">

                                                <strong>
                                                    {item.name}
                                                </strong>

                                            </div>

                                        </td>
                                        <td>

                                            <div className="redacao-preview">

                                                {item.email}

                                            </div>

                                        </td>
                                        <td>

                                            <div className="salas-list">

                                                {
                      item.salas.length > 0 ?
                      item.salas.map((sala, index) =>

                      <span
                        key={index}
                        className="badge badge-light">{`

                                                                ${t("legacy_sala")} `}
                        {sala.numero}

                                                            </span>

                      ) :
                      '-'
                      }

                                            </div>

                                        </td>
                                        {/* <td><img style={{ height: 60, width: 60, objectFit: 'contain' }} src={STORAGE_URL + STORAGE_URL + item.arquivo} /></td> */}

                                        <td>

                                            <div className="actions-group">

                                                <button
                        className="action-btn info"
                        onClick={() => {

                          GetRelatórioFiscal(item);

                        }}>

                                                    <MdFileDownload />
                                                </button>

                                                <button
                        className="action-btn danger"
                        onClick={() => {

                          setRedacaoId(item.id);

                          setShowWarning(true);

                        }}>

                                                    <MdDelete />
                                                </button>

                                            </div>

                                        </td>
                                    </tr>
                )}

                            </tbody>
                        </table>
                        {loading_fiscais == true &&
            <div className="row" style={{ margin: 0 }}> <div className="col-12 d-flex justify-content-center align-items-center">
                                {/* <div className="spinner-border text-primary" role="status"  >
                  </div> */}
                                <CircularProgress />
                            </div></div>

            }
                    </div>
                    {loading_fiscais == false && fiscais.length == 0 && <div className="empty-module">

                        <div className="empty-module-icon">
                            🛡️
                        </div>

                        <h3>{`
                            ${t("empty_no_proctor_found")}
                        `}</h3>

                        <p>
                            Vincule o primeiro fiscal ao processo.
                        </p>

                    </div>}

                    <Pagination
            className={pagination.last_page == 1 ? "hide" : ""}
            style={{ display: "flex", justifyContent: "flex-end" }}
            count={pagination.last_page}
            value={pagination.current_page}
            onChange={(_, value) => {
              setLoadingfiscais(true);
              console.log(_, value);
              let page = { ...pagination };
              page.current_page = value;
              setPagination(pagination);
              Getfiscais(value, search_oficial);
            }} />


                    {/* {this.state.andamento == true && <AvaliacaoAndamento get_fiscais={this.get_fiscais.bind(this)} {...this.props} />} */}

                </div>}

                {loading_screen == true && <div className="row"> <div className="col-12 d-flex justify-content-center align-items-center" style={{ marginTop: '2rem' }}>
                    {/* <div className="spinner-border text-primary" role="status"  >
              </div> */}
                    <CircularProgress />
                </div></div>}

                <SweetAlert
          warning
          title={t("legacy_atencao")}
          onConfirm={() => {
            setShowWarning(false);
            setLoadingfiscais(true);
            DeleteRedacao(fiscais_id);
            // this.delete_banner(this.state.banner_to_delete);
          }}
          onCancel={() => {
            setShowWarning(false);
          }}
          show={show_warning}
          confirmBtnText={t("ui_sim_desejo_desvincular_91364237")}
          cancelBtnText={t("legacy_cancelar")}
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          showCancel={true}>{t("ui_ao_desvincular_este_fiscal_ele_nao_tera_mais_acess_05fc2cf3")}


        </SweetAlert>


            </div>

        </div>);

};

export default FiscaisVinculados;
